export default class OrganizationViewModel {
    constructor(response) {
      this.id = response.id;
      this.name = response.name;
      this.authZeroId = response.authZeroId;
      this.currentSubscriptionPlanId = response.currentSubscriptionPlanId;
      this.subscriptionActive = response.subscriptionActive;
    }
  }